import { useQuery } from "@tanstack/react-query";

import { customFetch } from "../util/customFetch";

export function useForms({ enabled = true, params }) {
  const page = params.page || params.firstResult;
  const size = params.size || params.pageSize;
  const sortOrder = params.sortOrder || "desc";
  const sort = params.sortBy
    ? `${params.sortBy},${sortOrder}`
    : params.sort
      ? `${params.sort},${sortOrder}`
      : "";
  const queryParams = { page, size, sortOrder, sort };
  return useQuery({
    enabled,
    queryKey: ["forms", queryParams],
    queryFn: async () =>
      customFetch(
        `/api/smartform/{tenant}/forms?${new URLSearchParams(queryParams)}`,
      ),
  });
}

export function useFormsListMetadataByFormId({ enabled = true, body }) {
  return useQuery({
    enabled,
    queryKey: ["forms", "metadata", "by-id"],
    queryFn: async () =>
      customFetch(`/api/smartform/{tenant}/forms/list-by-form-id`, {
        method: "POST",
        body: JSON.stringify(body),
      }),
  });
}
